import {IS_LOADING,GET_TABLE_DATA,SET_ROUTER_TAGS,DELETE_ROUTE_TAGS,SET_SIDEBAR_ROUTERS,SET_TABLE_COLUMNS,SET_ROUTERS,SET_TABLE_SELECT,SET_SUBJECT_TYPE,IS_ACTIVE_KEY,SET_TABS,SET_TABS_NAME_OBJ,SET_BTN,SET_MENU_STATE,SET_AUD_UUID} from "./types";
import {findIndex} from "lodash";
const excludeTags = ['/dashboard', '/login', '/']
import {routes } from '../../src/router';
const mutations = {
  [IS_LOADING](state, isloading) {
    state.loading = isloading;
  },
  saveCurrDbSource(state,currDbSource){
    state.DateYear = currDbSource;
},

  [SET_BTN](state, btnArr) {
    state.BtnPermissionData = btnArr;
  },

  [SET_MENU_STATE](state, menuState) {
    state.isMenuState = menuState;
  },


  [SET_TABS_NAME_OBJ](state, tabsObj) {
    state.TabsPermissionName = tabsObj;
  },
  [SET_TABS](state, tabs) {
    state.TabsPermissionData = tabs;
  },
  [IS_ACTIVE_KEY](state, activeKey) {
    state.activeKey = activeKey;
  },
  [SET_TABLE_SELECT](state, tableSelect) {
    state.tableSelectArr = tableSelect;
  },
  [SET_ROUTERS](state, routers) {
    // if(routers.length!==0){}
    state.routers = routes.concat(routers);
    state.Myrouters=routers;
  },
  [SET_SIDEBAR_ROUTERS](state, routes){
    state.sidebarRouters = routes;
  },
  [SET_TABLE_COLUMNS](state, columns) {
    state.columns = columns;
  },
  [GET_TABLE_DATA](state, tableData) {
    state.tableData = tableData;
  },
  [SET_AUD_UUID](state, audUuid) {
    console.log(audUuid);
    state.audUuid = audUuid;
  },


  // [DELETE_ROUTER_TAGS](state, route) {
  //
  //   const { fullPath, path, meta,name,title} = route
  //   if (!excludeTags.includes(path)) {
  //     const flag = state.keepLiveTags.some((i) => i.fullPath != route.fullPath);
  //     if (!flag){
  //         return false
  //     }
  //
  //     if(title!=='登录'){
  //       state.keepLiveTags.splice(state.keepLiveTags.indexOf(name),1);
  //       // state.keepLiveTags.push({
  //       //   title: title,
  //       //   fullPath,
  //       //   name,
  //       //   path,
  //       // })
  //     }
  //
  //   }
  // },


  [SET_ROUTER_TAGS](state, route) {

    // state.keepLiveTags= route;

    const { fullPath, path, meta,name,title} = route
    if (!excludeTags.includes(path)) {
      if (state.keepLiveTags.some((i) => i.fullPath === route.fullPath))
        return false
      if(title!=='登录'){
        state.keepLiveTags.push({
          title: title,
          fullPath,
          name,
          path,
        })
      }

    }
  },
  // [SET_ROUTER_TAGS](state, route) {
  //   const { fullPath, path, meta } = route
  //   if (!excludeTags.includes(path)) {
  //     if (state.keepLiveTags.some((i) => i.fullPath === route.fullPath))
  //       return false
  //     if(meta.requireAuth){
  //       state.keepLiveTags.push({
  //         title: meta.title,
  //         fullPath,
  //         path,
  //       })
  //     }
  //
  //   }
  // },

  [DELETE_ROUTE_TAGS](state, route) {
    const { fullPath, path, meta,name,title} = route
    if (!excludeTags.includes(path)) {
      const flag = state.keepLiveTags.some((i) => i.name == name);
      if (!flag){
        return false
      }
      if(title!=='登录'){
        const index = state.keepLiveTags.findIndex(item => item.name == name);
        state.keepLiveTags.splice(index,1);
      }
    }
    // const index = findIndex(state.keepLiveTags, route)
    // if (index === -1) return false
    // state.keepLiveTags.splice(index, 1)
  }
}


export default {
  ...mutations
};




// WEBPACK FOOTER //
// ./src/store/mutations.js